// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Q9cB","left":"styles_left__18_6Y"};